import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer 
      className="py-8 bg-[#1A1A1A]"
      data-testid="footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex items-center justify-center">
          <div className="text-white/30 text-sm">
            {t('footer_copyright')}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
